// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"405":"b00747b0","3956":"b00747b0","4884":"b00747b0","5433":"b00747b0","8155":"e3c86118"}[chunkId] + ".chunk.css";
};